import { Routes } from '@angular/router';
import { DefaultBodyComponent } from './layout/default-body/default-body.component';
import { LoginComponent } from './pages/login/login.component';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
    },
    {
        path: 'login',
        component: LoginComponent,
    },
    {
        path: '',
        component: DefaultBodyComponent,
        data: {
            title: 'Dashboard'
        },
        children: [
            {
                path: '',
                loadChildren: () => import('./pages/pages.module').then((m) => m.PagesModule)
            },
            // {
            //     path: 'ui-componants',
            //     loadChildren: () => import('./ui-componants/ui-componants.module').then((m) => m.UiComponantsModule)
            // }
        ]
    }
];
